<template>
  <div>
    <StepForMobile
      :currentStep="4"
      :screenType="screenType"
      :title="this.$t('Finish')"
    />
    <div v-if="screenType !== 'desktop' && uploadStep === 4" class="btn-wrapper">
      <div
      @click="SET_UPLOAD_STEP(1)"
        class="start-btn-active d-flex justify-center"
        :class="screenType === 'desktop' ? 'start-btn' : 'start-btn-mobile'"
      >
        <h3 class="mx-1" role="button">{{ $t('Additional Sending') }}</h3>
        <v-icon color="white" class="mx-1">mdi-cached</v-icon>
      </div>
    </div>
  </div>
</template>
<script>
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'RestartWrapper',
  props: {
    screenType: String,
  },
  components: {
    StepForMobile,
  },
  methods: {
    ...mapMutations(['SET_UPLOAD_STEP']),
  },
    computed: {
        ...mapGetters(['uploadStep']),
    },
}
</script>

<style
  scoped
  lang="scss"
  src="@/components/WebsiteInterface/WebsiteInterfaceDesktop/Childern/UploadDesktop/Children/UploadingDetails/Children/StartRestartButtons/StartRestartButtons.scss"
></style>

<style scoped>
.btn-wrapper {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.2) 0px 0px 0px 1px !important;
  border-radius: 10px !important;
  padding: 8px;
  display: flex;
  justify-content: center;
}
</style>
